import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { HTTP } from "../api/http-common";

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const navigate = useNavigate();
  const [globalUserVar, setGlobalUserVar] = useState([]);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isActiveMember, setIsActiveMember] = useState(false);
  const [roleId, setRoleId] = useState(null)
  const [userInfo, setUserInfo] = useState(null)
  const [usermailToVerify, setUsermailToVerify] = useState("");

  const checkAccessToken = () => {
    const access_token = localStorage.getItem("access_token");
    if (access_token) {
      fetchUserData();
    } else {
      setGlobalUserVar([]);
      setIsAuthenticated(false)
      setIsActiveMember(false)
      setRoleId(null)
      setUserInfo(null)
    }
  };

  useEffect(() => {
    checkAccessToken();
  }, []);

  const fetchUserData = () => {
    const access_token = localStorage.getItem("access_token");
    const config = {
      headers: { "Content-Type": "application/json", token: access_token },
    };
    HTTP.get("user/me", config)
      .then((response) => {
        if (response.status === 200) {
          localStorage.setItem("userObj", JSON.stringify(response.data));
          setGlobalUserVar(JSON.stringify(response.data));
          setIsAuthenticated(response.data.email_verified);
          setIsActiveMember(response.data.active_member);
          setRoleId(response.data.role_id)
          setUserInfo(response.data)
        }
        
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // Handle unauthorized error
          // localStorage.removeItem('access_token');
          // navigate('/login'); // Redirect to login page
        }
      });


  };

  // Fetch coupons
  const fetchCoupons = async (filters = {}, pagination = null, sorting = null) => {
    const access_token = localStorage.getItem("access_token");
    const config = {
      headers: { "Content-Type": "application/json", token: access_token },
    };

    try {
      const response = await HTTP.post(
        "coupon/get_coupons",
        {
          filters,
          pagination,
          sorting,
        },
        config // The config should be the third parameter
      );
      if (response.status === 200) {
        return response.data; // Contains total_count and contents
      }
    } catch (error) {
      console.error("Error fetching coupons:", error);
      throw error;
    }
  };

  return (
    <GlobalContext.Provider
      value={{
        globalUserVar,
        setGlobalUserVar,
        isAuthenticated,
        setIsAuthenticated,
        usermailToVerify,
        setUsermailToVerify,
        fetchCoupons, // Provide fetchCoupons function via context
        isActiveMember,
        setIsActiveMember,
        roleId,
        userInfo,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = () => useContext(GlobalContext);
